import useTagsViewStore from '@/store/modules/tagsView';
import router from '@/router';

export default {
    // 刷新当前 tab（清缓存 + /redirect 重进，对齐 EB 顶栏刷新）
    refreshPage(obj?: any) {
        const current = router.currentRoute.value;
        const { path, query } = current;

        if (obj === undefined) {
            obj = {
                name: current.name,
                path,
                query: { ...query },
                meta: current.meta,
            };
            if (!obj.name) {
                current.matched.forEach(m => {
                    const compName = m.components?.default?.name as string | undefined;
                    if (compName && !['Layout', 'ParentView', 'LegacyLayout'].includes(compName)) {
                        obj = { name: compName, path, query: { ...query }, meta: current.meta };
                    }
                });
            }
        }

        const redirect = () =>
            router.replace({
                path: '/redirect' + (obj.path || path),
                query: obj.query || query,
            });

        const tagsStore = useTagsViewStore();
        if (obj?.name) {
            return tagsStore.delCachedView(obj).then(redirect);
        }
        return redirect();
    },
    // 关闭当前tab页签，打开新页签
    closeOpenPage(obj?: any) {
        useTagsViewStore().delView(router.currentRoute.value);
        if (obj !== undefined) {
            return router.push(obj);
        }
    },
    // 关闭指定tab页签
    closePage(obj?: any) {
        if (obj === undefined) {
            return useTagsViewStore()
                .delView(router.currentRoute.value)
                .then(({ lastPath }) => {
                    return router.push(lastPath || '/index');
                });
        }
        return useTagsViewStore().delView(obj);
    },
    // 关闭所有tab页签
    closeAllPage() {
        return useTagsViewStore().delAllViews();
    },
    // 关闭左侧tab页签
    closeLeftPage(obj: any) {
        return useTagsViewStore().delLeftTags(obj || router.currentRoute.value);
    },
    // 关闭右侧tab页签
    closeRightPage(obj: any) {
        return useTagsViewStore().delRightTags(obj || router.currentRoute.value);
    },
    // 关闭其他tab页签
    closeOtherPage(obj: any) {
        return useTagsViewStore().delOthersViews(obj || router.currentRoute.value);
    },
    // 打开tab页签
    openPage(url: string) {
        return router.push(url);
    },
    // 修改tab页签
    updatePage(obj: any) {
        return useTagsViewStore().updateVisitedView(obj);
    },
};
